import { getLocalStorage } from '@shared/core';
import { useEffect, useState } from 'react';
import { addError } from '@shared/utils/logger';

const localStorage = getLocalStorage();

const languageComingSoonMap: Record<string, string> = {
  en: 'Support for non-English languages coming soon!',
  es: '¡Próximamente habrá soporte para español!',
  de: 'Unterstützung für Deutsch kommt bald!',
  fr: 'Prise en charge du français bientôt disponible !',
  it: "Il supporto per l'italiano arriverà presto!",
  ja: 'まもなく日本語のサポートが追加されます！'
};

// TODO - temp localstorage language detection for disclaimer
export const useLocaleDisclaimer = () => {
  const [localeDisclaimer, setLocaleDisclaimer] = useState<string | null>(null);

  useEffect(() => {
    const joyLocale = localStorage.getItem('joyLocale');

    if (joyLocale) {
      try {
        const parsedLocale = JSON.parse(joyLocale);
        const language = String(parsedLocale.language);

        if (language === 'en') {
          return;
        }

        if (language in languageComingSoonMap) {
          setLocaleDisclaimer(languageComingSoonMap[language]);
        } else {
          setLocaleDisclaimer(languageComingSoonMap['en']);
          addError(`useLocaleDisclaimer: Unsupported language: ${language} - falling back to en`);
        }
      } catch (e) {
        console.error(e);
      }
    }
  }, []);

  return localeDisclaimer;
};
